let language = {
    "RESOURCE-LIBRARY-ALERT-CREATE-FAIL-TITLE":"创建失败",
    "RESOURCE-LIBRARY-ALERT-CREATE-FAIL-CONTENT":"目录文件夹的最大限制是20个",
    "RESOURCE-LIBRARY-ALERT-DELETE-SELECTED-FILE-TITLE":"删除文件",
    "RESOURCE-LIBRARY-ALERT-DELETE-SELECTED-FILE-CONTENT":"您确定要删除所选的文件吗？",
    "RESOURCE-LIBRARY-ALERT-DELETE-FILE-TITLE":"删除文件",
    "RESOURCE-LIBRARY-ALERT-DELETE-FILE-CONTENT":"您确定要删除所选的文件吗？",
    "RESOURCE-LIBRARY-ALERT-DELETE-FOLDER-TITLE":"删除文件夹",
    "RESOURCE-LIBRARY-ALERT-DELETE-FOLDER-CONTENT":"您确定要删除选定的文件夹吗？",
};

export { language }